module.exports = __webpack_public_path__ + "static/media/icon-hcp-steps-schedule.26e5aad7.svg";